var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 74,
    viewBox: "0 0 83 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.833 24.5085C60.727 23.1275 58.8688 12.2556 50.8277 4.46048C62.712 5.90546 70.6055 17.1076 69.3758 27.6047C68.146 38.1019 61.2725 42.7695 57.462 44.7768C60.8674 37.7871 61.4853 33.0041 60.833 24.5085Z",
    fill: "#55C65C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1332 48.5855C63.2979 47.8358 71.9802 41.0337 75.0168 30.2541C79.3938 41.397 73.2894 53.6662 63.4692 57.5733C53.649 61.4804 46.2754 57.6512 42.6982 55.2526C50.4665 54.9267 54.9685 53.1972 62.1332 48.5855Z",
    fill: "#55C65C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7827 60.8407C44.0158 61.4716 54.2576 65.5648 65.1047 62.7785C57.6659 72.1586 43.9903 73.0398 35.6807 66.5089C27.3711 59.978 26.9804 51.6786 27.2586 47.3807C31.4409 53.9352 35.197 56.9602 42.7827 60.8407Z",
    fill: "#55C65C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7829 49.6693C21.9431 51.0451 24.2266 61.8357 32.5675 69.3091C20.6357 68.3318 12.3084 57.4482 13.1252 46.9108C13.9419 36.3735 20.6269 31.4397 24.3556 29.2843C21.2273 36.4023 20.7975 41.2059 21.7829 49.6693Z",
    fill: "#55C65C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7483 25.6509C19.5901 26.4105 10.9662 33.2865 8.02172 44.0917C3.54971 32.9866 9.54906 20.6657 19.3356 16.6749C29.1221 12.684 36.5281 16.4501 40.1256 18.818C32.3604 19.2103 27.8733 20.9782 20.7483 25.6509Z",
    fill: "#55C65C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.826 13.2241C38.585 12.609 28.2921 8.64574 17.4812 11.5691C24.8007 2.09559 38.464 1.04133 46.8556 7.46651C55.2473 13.8917 55.743 22.1855 55.5192 26.4865C51.2543 19.9855 47.4602 17.0083 39.826 13.2241Z",
    fill: "#55C65C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7095a4ab60df6130fcde37a8d9b00d58.svg";
export { ForwardRef as ReactComponent };